<template>
<div>
    <div v-if="paciente && paciente.id_pessoa && paciente.cadastro" class="d-flex justify-content-between">
        <div> 
            <h3 class="mb-0">{{ paciente.search }}</h3>
            <small class="text-muted">
                <span v-if="marcacao && marcacao.plano">
                    {{ marcacao.plano.search }},     
                </span>
                <span v-else-if="paciente.paciente_unidade && paciente.paciente_unidade.plano">
                    {{ paciente.paciente_unidade.plano.search }}, 
                </span>
                {{ paciente.cadastro.sexo }}, 
                {{ paciente.cadastro.idade }}
            </small>
            <span v-if="paciente.cadastro.fl_estrangeiro && !is_vtr" class="badge badge-secondary ml-2">
                Estrangeiro ou Sem CPF
            </span>
            <span v-if="paciente.sinalizadores">
                <span v-for="(sinal, isx) in paciente.sinalizadores" :key="isx" :title="sinal.sinalizador.search">
                    <i class="fa-fw" :class="( sinal.sinalizador.st_icon ? sinal.sinalizador.st_icon : 'fas fa-flag') + ' text-'  + sinal.sinalizador.st_cor" aria-hidden="true"></i>
                </span>
            </span>
            
            <span class="badge ml-2" :class="'badge-' + paciente.nps.color" v-if="paciente.nps">
                <i class="fa-solid fa-star mr-1"></i>
                {{ paciente.nps.score }}
            </span>
        </div>
        
        <div class="d-flex"> 
            <div class="ml-3 my-1">
                <az-float-panel
                    classe="left"
                    title="Pacotes"
                    icon="fas fa-layer-group"
                    color="light"
                    custom_width="400px"
                    v-if="paciente && paciente.atendimento_pacotes && paciente.atendimento_pacotes.length">
                    <pacotes-do-paciente :pacotes="paciente.atendimento_pacotes"></pacotes-do-paciente>
                </az-float-panel>
            </div>
            <div>
                <button type="button" class="btn btn-link" @click="verPerfil()">
                    <i class="far fa-id-card"></i>
                    ver perfil
                </button>
            </div>
            <button type="button" class="ml-3 btn btn-link" v-if="1 == 0"
                @click="exibirPacotes()">
                <i class="fas fa-layer-group"></i>
            </button>
        </div>
    </div>

    <div v-else-if="cadastro_temporario">
        <div> 
            <h3 class="mb-0">{{ cadastro_temporario.st_nome }}</h3>
            <small class="text-muted">
                <span v-if="marcacao && marcacao.plano">
                    {{ marcacao.plano.search }},     
                </span>
                {{ cadastro_temporario.sexo }}, 
                {{ cadastro_temporario.idade }}
            </small>
        </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="tituloPacotes" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Pacotes</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                </div>
                <div class="modal-body" v-if="paciente && paciente.atendimento_pacotes">
                    <pacotes-do-paciente :pacotes="paciente.atendimento_pacotes"></pacotes-do-paciente>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import $ from 'jquery';
import PacotesDoPaciente from '../shared/PacotesDoPaciente.vue';
import AzFloatPanel from '../util/AzFloatPanel.vue';

export default {
    data () { 
        return { 
            
        }
    },

    components: { 
        PacotesDoPaciente,
        AzFloatPanel,
    },

    props: [ 'paciente', 'cadastro_temporario', 'marcacao' ],

    computed: { 
        is_vtr: function () { 
            return ( this.$store.state.user && this.$store.state.user.vtr ) ? true : false; 
        }
    },

    methods: { 
        verPerfil() { 
            // $('.modal').modal('hide');
            this.$root.perfil(this.paciente);
        },

        exibirPacotes () { 
            $('#tituloPacotes').modal('show');
        }

    }
}
</script>